(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["global-countdown-timer"] && !Shopify.designMode) return;
  try {
    (() => {
    const countdown = document.querySelector('.global-countdown-timer');
    if (!countdown) return;

    countdown.querySelector('.js-close-countdown-timer').addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      countdown.hidden = true;
    });

    const scrollTopButton = document.querySelector(
      '.template-collection [data-scroll-top-btn], .template-search [data-scroll-top-btn]'
    );
    if (!scrollTopButton) return;

    const countdownContent = countdown.querySelector('.global-countdown-timer__inner');
    const updateScrollTopPosition = () => {
      const bounds = countdownContent.getBoundingClientRect();
      if (bounds.height === 0) {
        scrollTopButton.style.removeProperty('bottom');
        return;
      }

      scrollTopButton.style.bottom = `${window.innerHeight - bounds.top + 16}px`;
    };

    new ResizeObserver(updateScrollTopPosition).observe(countdown);
    new MutationObserver(updateScrollTopPosition).observe(countdown, {
      attributes: true,
      attributeFilter: ['hidden', 'style'],
    });
    window.addEventListener('resize', updateScrollTopPosition);
    updateScrollTopPosition();
  })();
  } catch(e) { console.error(e); }
})();

})();
